export default "__VITE_ASSET__Bp6zkuAS__"